import { dotnetBackendRevealBaseUrl } from '../config/dotnetBackendEnv';

declare let $: any;
$.ig.RevealSdkSettings.setBaseUrl(dotnetBackendRevealBaseUrl);

export const appTheme = (themePreference: string | null | undefined): any => {

    const normalised = (themePreference ?? '').trim().toLowerCase();
    if (normalised === 'light') {
        $.ig.RevealSdkSettings.theme = new $.ig.MountainLightTheme();
        $.ig.RevealSdkSettings.theme.isDark = false;
    } else {
        $.ig.RevealSdkSettings.theme = new $.ig.MountainDarkTheme();
        $.ig.RevealSdkSettings.theme.isDark = true;
    }
    var theme = $.ig.RevealSdkSettings.theme.clone();  
    //theme.chartColors = ["rgb(76, 45, 129)","rgb(29, 79, 160)",  "rgb(18, 133, 199)"]
    theme.chartColors = ["rgb(23, 104, 238)","rgb(135, 206, 250)",  "rgb(175, 238, 238)", "rgb(90, 206, 193)", "rgb(226, 105, 81)", "rgb(244, 199, 190)", "rgb(154, 162, 221)", "rgb(219, 223, 233)"]
    theme.regularFont = "Segoe UI";
    theme.mediumFont = "Segoe UI";
    theme.boldFont = "Segoe UI";
    theme.visualizationMargin = 5;
    // theme.visualizationBackgroundColor = "#ccffffff" //"rgba(255, 255, 255, 0.5)";
    // theme.dashboardBackgroundColor = "#00000000";
    return theme;
}
